<div *ngIf="!tokenExtinct" class="content">

  <h4>Podaj kod weryfikacyjny</h4>
  <p>Jeśli istnieje konto powiązane z numerem {{maskedPhoneNumber}}, wyślemy SMS z kodem weryfikacyjnym. Wprowadź go poniżej.</p>

  <form [formGroup]="verificationGroup" class="form" (submit)="onSubmit()">

    <div class="input-error-group">
      <input #input type="text" class="control input" [class.control_error]="errorMessage || codeControl.hasError('required') && codeControl.dirty" formControlName="code"
             AllowOnly="numeric" maxlength="4">

      <div class="controls__errors" *ngIf="errorMessage">
        <span>{{errorMessage}}</span>
      </div>
      <div *ngIf="codeControl.hasError('required') && codeControl.dirty" class="controls__errors">
        <span>Pole jest wymagane</span>
      </div>
    </div>

    <button class="btn btn_bg" [disabled]="loading">Gotowe</button>


    <span (click)="goBack.emit()" class="link go-back-link mt-4">Wróć</span>

  </form>
</div>
<div *ngIf="tokenExtinct" class="token-extinct">
  <img class="icon" src="assets/img/shoper-connect/exclamation.svg" alt="">
  <h4>
    Kod SMS wygasł
  </h4>
  <p>
    Minął czas na wpisanie kodu. Możesz ponownie poprosić o SMS na numer {{maskedPhoneNumber}}.
  </p>
  <p class="controls__errors" *ngIf="errorMessage">{{errorMessage}}</p>
  <button  (click)="sendSmsAgain()"  class="btn btn_bg" [disabled]="loading">wyślij SMS jeszcze raz</button>
</div>
